/* eslint-disable */
export default {
  noRecords: '최근 레코드를 찾을 수 없습니다.',
  inBound: '수신',
  outBound: '발신',
  missed: '부재중 전화',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
// @key: @#@"inBound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outBound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"missed"@#@ @source: @#@"Missed Call"@#@
